module.exports = __webpack_public_path__ + "static/media/logo-cliente.0f339cd3.gif";